import { useEffect, useRef, useState } from 'react'

const useCountdown = timestamp => {
    const [isExpired, setIsExpired] = useState(true)
    const [days, setDays] = useState(0)
    const [hours, setHours] = useState(0)
    const [minutes, setMinutes] = useState(0)
    const [seconds, setSeconds] = useState(0)

    const interval = useRef(null)

    const onExpire = () => {
        setDays(0)
        setHours(0)
        setMinutes(0)
        setSeconds(0)
        setIsExpired(true)
    }

    const startInterval = value => {
        interval.current = setInterval(function () {
            const now = Date.now()

            const distance = value - now

            setDays(Math.floor(distance / (1000 * 60 * 60 * 24)))
            setHours(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)))
            setMinutes(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)))
            setSeconds(Math.floor((distance % (1000 * 60)) / 1000))

            if (distance < 0) {
                clearInterval(interval.current)
                onExpire()
            }
        }, 1000)
    }

    useEffect(() => {
        setIsExpired(false)
        clearInterval(interval.current)
        startInterval(timestamp)
    }, [timestamp])

    return {
        isExpired,
        days,
        hours,
        minutes,
        seconds,
    }
}

export default useCountdown
